const OWNERSHIP_ROLES = new Set(['Admin', 'Super Admin']);
const CONTROL_CHARACTERS = /[\u0000-\u001F\u007F-\u009F]/;
const NOT_AVAILABLE = 'N/A';

export const DASHBOARD_OWNERSHIP_SESSION_KEY = 'dashboard.showOwnershipDetails';

export const isDashboardOwnershipRole = (role) => OWNERSHIP_ROLES.has(role);

export const normalizeDashboardOwnershipPath = (value) => {
  const rawPath = String(value ?? '').trim().replace(/\\/g, '/');
  if (!rawPath || CONTROL_CHARACTERS.test(rawPath)) {
    return '';
  }

  const segments = rawPath.split('/').filter(Boolean);
  if (segments.some((segment) => segment === '.' || segment === '..')) {
    return '';
  }

  return segments.join('/');
};

export const isDashboardOwnershipPathEligible = (currentPath) => {
  const normalizedPath = normalizeDashboardOwnershipPath(currentPath);
  return Boolean(normalizedPath && normalizedPath !== 'ov2');
};

const ownershipTypeKey = (isFile) => {
  if (isFile === true) {
    return 'file';
  }
  if (isFile === false) {
    return 'folder';
  }
  return '';
};

export const buildDashboardOwnershipRowKey = (currentPath, row = {}) => {
  const parentPath = normalizeDashboardOwnershipPath(currentPath);
  const childPath = normalizeDashboardOwnershipPath(row.directory);
  const typeKey = ownershipTypeKey(row.isFile);

  if (!parentPath || !childPath || childPath.includes('/') || !typeKey) {
    return '';
  }

  return `${parentPath}/${childPath}|${typeKey}`;
};

export const buildDashboardOwnershipItemKey = (item = {}) => {
  const safeItem = item || {};
  const relativePath = normalizeDashboardOwnershipPath(safeItem.relativePath);
  const typeKey = ownershipTypeKey(safeItem.isFile);

  if (!relativePath || !typeKey) {
    return '';
  }

  return `${relativePath}|${typeKey}`;
};

export const indexDashboardOwnership = (items = []) => {
  const ownershipByPath = new Map();

  if (!Array.isArray(items)) {
    return ownershipByPath;
  }

  items.forEach((item) => {
    const key = buildDashboardOwnershipItemKey(item);
    if (key) {
      ownershipByPath.set(key, item);
    }
  });

  return ownershipByPath;
};

const formatOwner = (value) => {
  if (value === null || value === undefined) {
    return NOT_AVAILABLE;
  }

  const owner = String(value).trim();
  return owner || NOT_AVAILABLE;
};

export const formatDashboardOwnership = (ownership) => ({
  created: formatOwner(ownership?.createdOwner),
  modified: formatOwner(ownership?.modifiedOwner)
});

export { NOT_AVAILABLE as DASHBOARD_OWNERSHIP_NOT_AVAILABLE };
